export const cmul = ([a, b], [c, d]) => [a * c - b * d, a * d + b * c];

export const cadd = ([a, b], [c, d]) => [a + c, b + d];

export const cpow = (z, n) => {
  let r = n & 1 ? z : [0, 1];
  while ((n >>= 1) > 0) {
    z = cmul(z, z);
    if (n & 1) r = cmul(r, z);
  }
  return r;
};

export default {
  cmul,
  cadd,
  cpow
};
